import React from "react";
import useLocale from "../../../../hooks/useLocale";
import {
  DialogActions,
  DialogContent,
  Button,
  TextField,
  Grid,
} from "@material-ui/core";

import GovGrDate from "../../../../components/GovGrDate";
import GovGrModal from "../../../../components/GovGrModal";
import GovGrTextField from "../../../../components/GovGrTextField";
import { Form, Formik } from "formik";
import { useQuery } from "react-query";
import GovGrButton from "../../../../components/GovGrButton";

const VisibilityDialog = ({ open, close, selectedItem }) => {
  const { t } = useLocale();
  const initialValues = {
    sailorIdentificationNumber: selectedItem?.s_ameth,
    sailorAni: selectedItem?.s_ani,
    sailorBirthDate: new Date(selectedItem?.s_birth_date),
    sailorDiploma: selectedItem?.d_name,
    sailorFatherName: selectedItem?.s_f_name,
    sailorFirstName: selectedItem?.s_first_name,
    sailorId: selectedItem?.s_id,
    sailorLastName: selectedItem?.s_last_name,
    sailorMotherName: selectedItem?.s_m_name,
  };

  return (
    <>
      <GovGrModal open={open} onClose={close} customContent="true">
        <div className="govgr-heading-l m-0">{t("Sailor Details")}</div>
        <DialogContent>
          <Formik initialValues={initialValues} enableReinitialize>
            <Form>
              <Grid container spacing={4}>
                <Grid item xs={6}>
                  <GovGrTextField
                    name="sailorIdentificationNumber"
                    label={t("Ameth")}
                  />
                </Grid>
                <Grid item xs={6}>
                  <GovGrTextField name="sailorAni" label={t("ANI")} />
                </Grid>
              </Grid>
              <Grid container spacing={4}>
                <Grid item xs={6}>
                  <GovGrTextField
                    name="sailorFirstName"
                    label={t("First Name")}
                  />
                </Grid>
                <Grid item xs={6}>
                  <GovGrTextField
                    name="sailorLastName"
                    label={t("Last Name")}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={4}>
                <Grid item xs={6}>
                  <GovGrTextField
                    name="sailorFatherName"
                    label={t("Father Name")}
                  />
                </Grid>
                <Grid item xs={6}>
                  <GovGrTextField
                    name="sailorMotherName"
                    label={t("Mother name")}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={4}>
                <Grid item xs={6}>
                  <GovGrDate name="sailorBirthDate" label={t("Birth Date")} />
                </Grid>
                <Grid item xs={6}>
                  <GovGrTextField
                    name="sailorDiploma"
                    label={t("Diploma Kind")}
                  />
                </Grid>
              </Grid>
            </Form>
          </Formik>
        </DialogContent>
        <DialogActions>
          <GovGrButton
            onClick={close}
            variant="secondary"
            buttonText={t("Close")}
          />
        </DialogActions>
      </GovGrModal>
    </>
  );
};

export default VisibilityDialog;
